const isSameRow = (rowX, rowY, getUniqueRowId) =>
  getUniqueRowId({ data: rowX }) === getUniqueRowId({ data: rowY });

export default isSameRow;
